import { Checkbox, Heading, Paragraph } from '@digdir/designsystemet-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useValgfriDetaljeringContext } from '../utils';
import {
  CheckedContentWrapper,
  LeftBorderedContent
} from '../../../oppvarming/form/components/common/styledComponents';

import { StyledCard } from './styledComponents';
import { DetailingCheckbox } from './detailingCheckbox';

export const BygningsformCheckBox = () => {
  const { t } = useTranslation('', { keyPrefix: 'form.valgfriDetaljering' });
  const { register, watch, setValue } = useValgfriDetaljeringContext();

  const veggerIsChecked = watch('vegger');
  const vinduerIsChecked = watch('vinduer');
  const bygningsformIsChecked = watch('bygningsform');

  return (
    <>
      <Checkbox {...register('bygningsform')} label={t(`detaljeringSelection.options.bygningsform.title`)} />

      {bygningsformIsChecked && (
        <CheckedContentWrapper>
          <LeftBorderedContent>
            <Heading data-size="2xs">{t(`detaljeringSelection.options.bygningsform.title`)}</Heading>
            <Paragraph>{t(`detaljeringSelection.options.bygningsform.description`)}</Paragraph>
          </LeftBorderedContent>
          <StyledCard isActive={veggerIsChecked}>
            <DetailingCheckbox name="vegger" onChange={() => setValue('vinduer', false)} />
          </StyledCard>
          <StyledCard isActive={vinduerIsChecked}>
            <DetailingCheckbox name="vinduer" disabled={!veggerIsChecked} />
          </StyledCard>
        </CheckedContentWrapper>
      )}
    </>
  );
};
